/* DriveStow hover previews: lazy product media, no autoplay offscreen */
(function(){
 'use strict';
 var rootSelector='[data-ds-hover-preview]';
 var canHover=window.matchMedia('(hover: hover) and (pointer: fine)');
 var reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
 function mount(preview){
  if(preview.dataset.dsBound==='1')return;
  preview.dataset.dsBound='1';
  var host=preview.parentElement;
  if(!host)return;
  var video=preview.querySelector('video');
  var frames=Array.prototype.slice.call(preview.querySelectorAll('[data-ds-hover-frame]'));
  var delayId=null,cycleId=null,index=0,active=false,token=0;
  function stop(){
   active=false;token+=1;
   window.clearTimeout(delayId);window.clearInterval(cycleId);
   delayId=null;cycleId=null;
   preview.classList.remove('is-playing');
   frames.forEach(function(frame){frame.classList.remove('is-current');});
   if(video){video.pause();try{video.currentTime=0}catch(e){}}
  }
  function playPhotos(){
   if(!frames.length)return;
   var t=token;
   frames.forEach(function(frame){
    if(!frame.getAttribute('src')&&frame.dataset.dsSrc){frame.src=frame.dataset.dsSrc;}
   });
   function show(i){
    if(!active||token!==t)return;
    var frame=frames[i];
    if(!frame.complete||!frame.naturalWidth)return;
    frames.forEach(function(img,j){img.classList.toggle('is-current',j===i)});
    preview.classList.add('is-playing');
   }
   index=0;
   if(frames[0].complete&&frames[0].naturalWidth)show(0);
   else frames[0].addEventListener('load',function(){show(0)},{once:true});
   cycleId=window.setInterval(function(){
    if(!active||token!==t)return;
    var next=(index+1)%frames.length;
    if(frames[next].complete&&frames[next].naturalWidth){index=next;show(index);}
   },1750);
  }
  function begin(){
   if(!active||reducedMotion.matches)return;
   if(video){
    video.muted=true;video.playsInline=true;video.loop=true;
    preview.classList.add('is-playing');
    var promise=video.play();
    if(promise&&typeof promise.catch==='function'){promise.catch(function(){preview.classList.remove('is-playing')});}
   }else{playPhotos();}
  }
  function enter(event){
   if((event.pointerType&&event.pointerType!=='mouse'&&event.pointerType!=='pen')||!canHover.matches||reducedMotion.matches)return;
   if(active)return;
   active=true;token+=1;
   delayId=window.setTimeout(begin,170);
  }
  host.addEventListener('pointerenter',enter);
  host.addEventListener('pointerleave',stop);
  host.addEventListener('pointercancel',stop);
  document.addEventListener('visibilitychange',function(){if(document.hidden&&active)stop();});
 }
 function init(){document.querySelectorAll(rootSelector).forEach(mount);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('shopify:section:reorder',init);
 var observer=new MutationObserver(function(mutations){
  for(var i=0;i<mutations.length;i++){
   if(mutations[i].addedNodes.length){init();break;}
  }
 });
 var target=document.querySelector('main')||document.body;
 if(target)observer.observe(target,{childList:true,subtree:true});
})();
